module.exports = __webpack_public_path__ + "img/adhka-yx1zn.004.73bff2f3.jpeg";